module.exports = __webpack_public_path__ + "img/AccuICAS.170e4cf7.png";